module.exports = "<div class=\"rc-icon\" *ngIf=\"visible\">\n  <img class=\"img-responsive\" src=\"/assets/app-icons/{{icon}}.svg\" />\n</div>\n"